export default {
      id: "calendar-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#calendar",
      toString: function () {
        return this.url;
      }
    }